//For General Case
export const updateStateWithoutNesting = (oldState, objectForUpdating) => {
  return {
    ...oldState,
    ...objectForUpdating,
  };
};
